import { useNavigate } from "react-router-dom";
import { Heart, ArrowRight, Trash2, Compass } from "lucide-react";
import { toast } from "sonner";
import { AccountShell } from "../../components/account/AccountShell";
import { useNotebook } from "../../hooks/useNotebook";

export default function AccountFavorites() {
  const navigate = useNavigate();
  const { data, toggleFavorite } = useNotebook();
  const favorites = data.favorites || [];

  const remove = (biz) => {
    toggleFavorite(biz);
    toast.success("Removed from favorites");
  };

  return (
    <AccountShell title="Favorites" subtitle="Your saved business ideas." testid="account-favorites-page">
      {favorites.length === 0 ? (
        <div className="bg-[#F7F7F7] rounded-2xl p-10 text-center" data-testid="no-favorites-state">
          <div className="w-12 h-12 rounded-xl bg-white text-[#D4AF37] flex items-center justify-center mx-auto mb-4">
            <Heart size={22} />
          </div>
          <p className="font-display font-semibold text-[#0F0F0F]">No favorites yet</p>
          <p className="text-sm text-[#687280] mt-1">Tap the heart on any idea to save it here.</p>
          <button
            onClick={() => navigate("/business-ideas")}
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#0F0F0F] text-white px-6 py-3 text-sm font-semibold hover:bg-[#1c1c1c] transition-colors"
            data-testid="favorites-browse-btn"
          >
            <Compass size={16} /> Browse Ideas
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="favorites-grid">
          {favorites.map((biz) => (
            <div
              key={biz.id}
              className="bg-white rounded-2xl p-6 border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col"
              data-testid={`favorite-card-${biz.id}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  {biz.category_name && (
                    <span className="inline-flex rounded-full bg-[#F7F7F7] text-[#687280] px-2.5 py-0.5 text-[11px] font-semibold mb-2">
                      {biz.category_name}
                    </span>
                  )}
                  <h3 className="font-display text-lg font-bold text-[#0F0F0F]">{biz.title}</h3>
                </div>
                <button
                  onClick={() => remove(biz)}
                  className="shrink-0 w-9 h-9 rounded-full border border-gray-200 flex items-center justify-center text-[#687280] hover:text-red-500 hover:border-red-200 transition-colors"
                  title="Remove"
                  data-testid={`remove-favorite-${biz.id}`}
                >
                  <Trash2 size={15} />
                </button>
              </div>
              <p className="text-sm text-[#687280] mt-3 flex-1 line-clamp-3">{biz.summary}</p>
              <button
                onClick={() => navigate(`/business/${biz.id}`)}
                className="mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-[#0F0F0F] text-white py-2.5 text-sm font-semibold hover:bg-[#1c1c1c] transition-colors"
                data-testid={`open-favorite-${biz.id}`}
              >
                View Details <ArrowRight size={15} />
              </button>
            </div>
          ))}
        </div>
      )}
    </AccountShell>
  );
}
